import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Thongtindoanhnghiepct = React.memo(function Thongtindoanhnghiepct(props) {
  const classes = useStyles();
  const { doanhnghiep } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th_dn} style={{ width: "30%" }}>
            Thông tin
          </th>
          <th className={classes.tablebc_th_dn}>Nội dung</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td_dn}>Mã trung tâm</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].ma}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Tên trung tâm</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].ten}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Địa chỉ</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].diachi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Huyện/TP</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].huyentp}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Phường/xã</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].phuongxa}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số điện thoại</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].sodienthoai}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Tổng số đăng kiểm viên</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].tongsodkv}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số đăng kiểm viên bậc cao</td>
          <td className={classes.tablebc_td_dn}>{doanhnghiep[0].dkvbaccao}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Tổng số dây chuyền</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].tongsodaychuyen}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số dây chuyền kiểm định</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].sldaychuyenkiemdinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Loại dây chuyền kiểm định</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].loaidaychuyenkiemdinh}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số dây chuyền hoạt động</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].sodaychuyenhoatdong}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Số nhân viên nghiệp vụ</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].sonhanviennghiepvu}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Thủ trưởng</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].thutruongdonvi}
          </td>
        </tr>
        <tr>
          <td className={classes.tablebc_td_dn}>Đơn vị quản lý</td>
          <td className={classes.tablebc_td_dn}>
            {doanhnghiep[0].coquanquanly}
          </td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = doanhnghiep.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table} style={{ height: "497px" }}>
      <a
        style={{
          display: "block",
          textAlign: "center",
          color: "blue",
          fontWeight: "bold",
          fontSize: 18,
          marginTop: 10,
        }}
      >
        THÔNG TIN TRUNG TÂM ĐĂNG KIỂM
      </a>
      <table className={classes.tablebc} style={{ marginTop: 8 }}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Thongtindoanhnghiepct.propTypes = {
  doanhnghiep: PropTypes.array,
};
export default Thongtindoanhnghiepct;
